angular.module('app').factory('ContentAttributeRepository',
    ['AprimaRestangular',
        function(AprimaRestangular) {
            'use strict';

            function getContentAttributes(clientId) {
                var params = {
                    ClientId: clientId
                };

                var restangular = AprimaRestangular.get('patient');
                return restangular.one('login/Content-Attributes/').get(params);
            }

            return {
                getContentAttributes: getContentAttributes
            };
    }]);